import React, { memo } from 'react';
import * as S from './Options.styled';
const OptionsItemComponent = ({ label, active = false, onClick }) => (React.createElement(S.ItemContainer, { "$active": active, onClick: onClick, "data-testid": "Options.Item" }, label));
export const OptionsItem = memo(OptionsItemComponent);
